<div class="btn-list">
  <div class="btn-icon" *ngIf="infoDemanda.canSeeEdit">
    <a [routerLink]="cadastro()">
      <img src="assets/images/svgs/Editar.svg">
    </a>
  </div>
  <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
</div>

<div class="info-page">
  <h3>Demandas de Monitoramento</h3>
</div>

<div class="list-info">
  <h4>Título</h4>
  <p>{{ infoDemanda.subject }}</p>
</div>

<div class="list-info">
  <h4>Descrição</h4>
  <p>{{ infoDemanda.description }}</p>
</div>

<div class="list-info">
  <h4>Status</h4>
  <p>{{ infoDemanda.issue_stat_name }}</p>
</div>

<div class="list-info">
  <h4>Andamento</h4>
  <p>{{ infoDemanda.issue_sub_stat_name }}</p>
</div>

<div class="list-info">
  <h4>Responsável</h4>
  <p>{{ infoDemanda.main_manager_name }}</p>
</div>

<div class="list-info">
  <h4>Prazo</h4>
  <p>{{ infoDemanda.dt_foreseen_end }}</p>
</div>

<div class="list-info">
  <h4>Prazo</h4>
  <p>{{ infoDemanda.dt_foreseen_end }}</p>
</div>

<div class="list-info m-b-xl">
  <h4>Link</h4>
  <p><a [href]="infoDemanda?.link" target="_blank">{{ infoDemanda?.link_label }}</a></p>
</div>

<div *ngIf="infoDemanda.test3">
  <div class="info-page">
    <h3>Diálogo</h3>
  </div>
  <div class="system-table table-container table-container-margin">
    <div class="system-table-conteiner">
      <table>
        <thead>
          <tr>
            <th>Mensagem</th>
            <th>Enviado em</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of infoDemanda.messages">
            <tr>
              <td class="title-width">{{ item.message }}</td>
              <td>
                <div class="destaque m-b-xs">{{ item.defendant_name }}</div>
                {{ item.ctr_dth_inc }}
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!infoDemanda.messages?.length">
            <td colspan="2" class="text-center"> Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div *ngIf="infoDemanda.test3 && infoDemanda.issue_stat_id == 1">
  <div class="info-page">
    <h3>Nova mensagem</h3>
  </div>

  <form [formGroup]="form" (ngSubmit)="salvar()" *ngIf="!isLoading">
    <div class="form-group row">
      <div class="col-sm-8">
        <label class="col-sm-12 pb-1">Mensagem</label>
        <textarea id="message" class="form-control" rows="4" formControlName="message"></textarea>
        <app-field-message [field]="fieldMessageRequired('message')" [erros]="fieldErros('message')"></app-field-message>
      </div>
    </div>
    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button *ngIf="infoDemanda.canSave" class="btn btn-danger" (click)="concluir()">Concluir demanda</button>&nbsp;
        <button *ngIf="infoDemanda.test6 && infoDemanda.issue_sub_stat_id == 2" class="btn btn-success" type="submit" (click)="transferir()">Transferir para demandado</button>
        <button *ngIf="infoDemanda.test4 && infoDemanda.issue_sub_stat_id == 1" class="btn btn-success" type="submit" (click)="transferir()">Transferir para demandante</button>&nbsp;
        <button *ngIf="infoDemanda.canSave || (infoDemanda.test6 && infoDemanda.issue_sub_stat_id == 2) || (infoDemanda.test4 && infoDemanda.issue_sub_stat_id == 1)" class="btn btn-primary" type="submit">Salvar</button>
      </div>
    </div>
  </form>
</div>